module.exports = __webpack_public_path__ + "img/Group2582.231317b9.png";